import React from 'react'

import ConfirmPassword from '../components/Auth/ConfirmPassword/ConfirmPassword'

const ConfirmPasswordPage = () => {
  return <ConfirmPassword />
}

export default ConfirmPasswordPage
